import EnvUtil from '../util/EnvUtil'
import { gsap } from 'gsap'


class SlideItem
{
  // ---------------------------------------------------------------------------------------------------------
	// --	SlideItem
	// ---------------------------------------------------------------------------------------------------------

  constructor(dom){

    //DOM参照
    this.item = dom
    //this.prize = this.item.find('.icon-prize')
    this.bg = this.item.find('.slide-item__bg')
    this.wrapper = this.item.find('.slide-item__wrapper')
    this.info = this.item.find('.slide-item__infoWrap')
    this.title = this.item.find('.slide-item__title')
    this.jp = this.item.find('.slide-item__title--jp')
    this.en = this.item.find('.slide-item__title--en')
    this.summary = this.item.find('.slide-item__summary')
    this.play = this.item.find('.c-btnPlay')

    //プレイボタンのアクション
    this.play.hover(
      ()=>{
        gsap.killTweensOf(this.play)
        gsap.to(this.play, 0.3, {
          scaleX  :1.1,
          scaleY  :1.1
        })
      },
      ()=>{
        gsap.killTweensOf(this.play)
        gsap.to(this.play, 0.3, {
          scaleX  :1.0,
          scaleY  :1.0
        })
      }
    )

    //テキストを配列に格納
    this.txtArray = [this.info, this.jp, this.en, this.summary]

    //リセット
    this.reset()
  }

  reset()
  {
    //非表示にする
    this.item.hide()
    this.item.css('z-index', 1)

    //ボタンアクション
    this.item.css('pointer-events', 'none')

    //ラッパーリセット
    if (this.wrapper.length > 0) {
      gsap.killTweensOf(this.wrapper)
      gsap.set(this.wrapper, {alpha:1, scaleX:1, scaleY:1})
    }

    //Playボタンリセット
    if (this.play.length > 0) {
      gsap.killTweensOf(this.play)
      gsap.set(this.play, {alpha:0, scaleX:0.6, scaleY:0.6})
    }
  }

  show()
  {
    //アイテム表示
    this.item.show()
    this.item.css('z-index', 3)

    //背景の演出
    gsap.killTweensOf(this.bg)
    gsap.set(this.bg, {scaleX:1.15, scaleY:1.15, alpha:0})
    gsap.to(this.bg, 1.0, {alpha:1, ease:'none'})
    gsap.to(this.bg, 1.0, {
      scaleX  :1.1,
      scaleY  :1.1,
      ease    :'power4.out'
    })
    gsap.to(this.bg, 9, {
      scaleX  :1,
      scaleY  :1,
      delay   :1.0,
      ease    :'linear'
    })

    //ラッパーリセット
    if (this.wrapper.length > 0) {
      gsap.killTweensOf(this.wrapper)
      gsap.set(this.wrapper, {alpha:1, scaleX:1, scaleY:1})
    }

    //テキスト表示
    for(let i=0; i<this.txtArray.length; i++)
    {
      //テキスト参照
      const txt = this.txtArray[i]
      if (txt.length === 0) continue

      //テキスト初期化
      gsap.killTweensOf(txt)
      gsap.set(txt, {alpha:0, y:10})

      //テキスト表示
      gsap.to(txt, 0.6, {
        alpha :1,
        y     :0,
        delay :0.5 + 0.3 * i
      })
    }

    //ライン表示
    gsap.delayedCall(0.8, ()=>{
      this.title.addClass('show')
    })

    //プレイボタン表示
    if (this.play.length > 0) {
      gsap.killTweensOf(this.play)
      gsap.set(this.play, {alpha:0, scaleX:0.6, scaleY:0.6})
      gsap.to(this.play, 0.6, {
        alpha       :1,
        scaleX      :1,
        scaleY      :1,
        ease        :'back.out',
        delay       :1.7,
        onComplete  :()=>{
          this.item.css('pointer-events', 'auto')
        }
      })
    } else {
      this.item.css('pointer-events', 'auto')
    }
  }

  leave()
  {
    //背面に
    this.item.css('z-index', 2)

    //プレイボタン操作不可に
    this.item.css('pointer-events', 'none')

    //ラインを消す
    this.title.removeClass('show')

    //フェードアウト
    if (this.wrapper.length > 0) {
      gsap.killTweensOf(this.wrapper)
      gsap.to(this.wrapper, 0.3, {
        alpha   :0,
        scaleX  :0.95,
        scaleY  :0.95
      })
    }

    //リセット
    gsap.delayedCall(1.0, ()=>{
      this.reset()
    })
  }


  
	// ---------------------------------------------------------------------------------------------------------
}

export default SlideItem